// pages/IMISCities.jsx
import React, { useEffect, useState } from "react";
import Common from "../../Components/Layouts/Common";
import DropDown from "../../Components/UI/Inputs/DropDown";
import useWindowWidth from "../../Hooks/useWindowWidth";
import useApi from "../../Hooks/useApi";
import showToast from "../../Helpers/toast";
import Box from "../../Components/CityFeatures/Box";
import {
  fetchIMISCityData,
  fetchIMISIndicatorsList,
} from "../../Utils/imisCityDashboardUtils";
import { useTranslation } from "react-i18next";

const IMISCities = () => {
  const width = useWindowWidth();
  const { request } = useApi();
  const { t } = useTranslation();
  const [location, setLocation] = useState();
  const [year, setYear] = useState();
  const [fetchData, setFetchData] = useState([]);
  const [locationOptions, setLocationOptions] = useState([]);
  const [indicatorsData, setIndicatorsData] = useState({});

  useEffect(() => {
    const fetchCityYearListData = async () => {
      try {
        await fetchIMISCityData(request, setFetchData);
      } catch (error) {
        console.log(error);
      }
    };
    fetchCityYearListData();
  }, [request]);

  useEffect(() => {
    setLocationOptions(fetchData.filter((item) => item.status === "PUBLISHED"));
  }, [fetchData]);

  useEffect(() => {
    if (!location || !year) return;

    const fetchIndicators = async () => {
      try {
        await fetchIMISIndicatorsList(
          request,
          { city: location, year },
          setIndicatorsData
        );
      } catch (error) {
        console.log(error);
        showToast({ message: error?.response?.data?.message, type: "error" });
      }
    };

    fetchIndicators();
  }, [location, year, request]);

  const dropDownStyle = {
    width: width >= 340 ? "15rem" : "10rem",
    backgroundColor: "#2F4B7C",
    color: "white",
  };

  const cityOptions = [
    ...new Set(locationOptions.map((item) => item.city)),
  ].map((city) => ({
    name: city,
    value: city,
  }));

  const yearOptions = location
    ? [
        ...new Set(
          locationOptions
            .filter((item) => item.city === location)
            .map((item) => item.year)
        ),
      ].map((year) => ({ name: year, value: year }))
    : [];

  return (
    <Common headline="IMIS Cities CWIS Dashboard">
      <div className="sticky top-[-50px] bg-white z-10 pb-4">
        <h2>{t("other.select_city_year")}</h2>
        <div className="flex gap-3 mt-3">
          <DropDown
            setter={(value) => {
              setLocation(value);
              setYear("");
            }}
            placeholder={t("other.select_city")}
            value={location || ""}
            options={cityOptions}
            style={dropDownStyle}
          />
          <DropDown
            searchAble={false}
            setter={setYear}
            placeholder={t("other.select_year")}
            value={year}
            options={yearOptions}
            style={dropDownStyle}
          />
        </div>
      </div>
      <div id="Indicators">
        <div className="mt-4 mb-8">
          <div>
            {year && location ? (
              <div className="border border-[#2F4B7C] px-2 py-4 md:py-4 lg:px-8 ">
                {indicatorsData && Object.keys(indicatorsData)?.length > 0 ? (
                  Object.entries(indicatorsData)?.map(
                    ([dataItemName, dataItemValues], index) => (
                      <React.Fragment key={dataItemName}>
                        {index ? <hr className="my-4" /> : null}
                        <p className="font-semibold text-base text-start text-[#2F4B7C] mb-2 capitalize">
                          {dataItemName}
                        </p>
                        <IndicatorsInfos indicators={dataItemValues} />
                      </React.Fragment>
                    )
                  )
                ) : (
                  <p className="text-center text-lg">No Data Found</p>
                )}
              </div>
            ) : (
              <p className="text-center text-lg border border-[#2F4B7C] px-2 py-8 md:py-4 lg:px-8 lg:py-12">
                Select city and year
              </p>
            )}
          </div>
        </div>
      </div>
    </Common>
  );
};

export default IMISCities;

const IndicatorsInfos = ({ indicators }) => {
  return (
    <div
      className="w-full grid grid-cols-1 sm:grid-cols-2 2xl:grid-cols-3 gap-4"
      style={{ color: "#2F4B7C" }}
    >
      {indicators && Object.keys(indicators)?.length > 0
        ? indicators?.map((i, idx) => (
            <Box
              key={idx}
              value={i.value}
              unit={i.unit}
              text={i.name}
              icon={i.icon}
              color={i.color}
            />
          ))
        : null}
    </div>
  );
};
